import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDProducts_View_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDProducts_View_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  SelectSTDProducts: any[];
  SelectSTDProducts_dummy: any[];
  STDGetEquivalentProducts: any[];
  STDGetEquivalentProducts_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp100166Visible: "visible" | "hidden";
  isComp623809Visible: "visible" | "hidden";
}

export class STDProducts_View_ScreenBase extends React.PureComponent<
  ISTDProducts_View_ScreenProps,
  any
> {
  stdproducts_view_396436_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "822a5586-0197-4c1b-b64a-c29155aa3faa",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Ürün Detay" },
        { Id: 873441, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 591400, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 934644, PropertyName: "value", Value: "Oluşturulma Tarihi" },
        { Id: 794086, PropertyName: "value", Value: "Güncelleme Tarihi" },
        { Id: 215818, PropertyName: "value", Value: "Muadil Ürünler" },
        { Id: 437531, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 73114, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 145901, PropertyName: "title", Value: "Title" },
        { Id: 384211, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 417765, PropertyName: "value", Value: "[datafield:productname]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdproducts_view_396436_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      SelectSTDProducts: [],
      STDGetEquivalentProducts: [],
      NAVIGATE: "",
      isComp100166Visible: "hidden",
      isComp623809Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdproducts_view", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDProducts_ViewPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdproducts_view", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdproducts_view", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDProducts_ViewPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDProducts_ViewPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      RealProduct_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDProducts_View/STDProducts_ViewPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp100166Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsCreate
            : null
        ),
        true
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].productsEdit
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].productsEdit
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.SelectSTDProducts = result?.data.selectSTDProducts;
    formVars.stdproducts_view_264066_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].productName
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].productName
        : null
    );
    formVars.stdproducts_view_154236_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].productCode
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].productCode
        : null
    );
    formVars.stdproducts_view_165814_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].createdAt
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].createdAt
        : null
    );
    formVars.stdproducts_view_329623_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].updatedAt
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].updatedAt
        : null
    );
    stateVars.STDGetEquivalentProducts = result?.data.stdGetEquivalentProducts;

    stateVars.isComp623809Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.STDGetEquivalentProducts !== undefined
            ? stateVars.STDGetEquivalentProducts?.length > 0
              ? stateVars.STDGetEquivalentProducts[0].id
              : null
            : this.state.STDGetEquivalentProducts?.length > 0
            ? this.state.STDGetEquivalentProducts[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDProducts_ViewPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDProducts_ViewPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdproducts_view_264066_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].productName
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].productName
        : null
    );

    formVars.stdproducts_view_154236_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].productCode
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].productCode
        : null
    );

    formVars.stdproducts_view_165814_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].createdAt
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].createdAt
        : null
    );

    formVars.stdproducts_view_329623_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDProducts !== undefined
        ? stateVars.SelectSTDProducts?.length > 0
          ? stateVars.SelectSTDProducts[0].updatedAt
          : null
        : this.state.SelectSTDProducts?.length > 0
        ? this.state.SelectSTDProducts[0].updatedAt
        : null
    );

    stateVars.isComp100166Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsCreate
            : null
        ),
        true
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].productsEdit
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].productsEdit
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp623809Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.STDGetEquivalentProducts !== undefined
            ? stateVars.STDGetEquivalentProducts?.length > 0
              ? stateVars.STDGetEquivalentProducts[0].id
              : null
            : this.state.STDGetEquivalentProducts?.length > 0
            ? this.state.STDGetEquivalentProducts[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_396436 =
      stateVars.STDGetEquivalentProducts ?? this.state.STDGetEquivalentProducts;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDProducts_ViewComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDProducts_ViewComponent_952857_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "STDProducts_Equivalence_Form",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDProducts_View",
      "STDProducts_Equivalence_Form",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "271353",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [271353] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDProducts_View"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDProducts_ViewPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDProducts_ViewPageInit();
    }
  }
}
